__turbopack_context__.v({
  "author": "quote-module-scss-module__1InMkG__author",
  "fill-step-angry": "quote-module-scss-module__1InMkG__fill-step-angry",
  "fill-step-before-midnight": "quote-module-scss-module__1InMkG__fill-step-before-midnight",
  "fill-step-coal-mine-canary": "quote-module-scss-module__1InMkG__fill-step-coal-mine-canary",
  "fill-step-coal-mine-canary-down": "quote-module-scss-module__1InMkG__fill-step-coal-mine-canary-down",
  "fill-step-cold-steel": "quote-module-scss-module__1InMkG__fill-step-cold-steel",
  "fill-step-cyanora": "quote-module-scss-module__1InMkG__fill-step-cyanora",
  "fill-step-cyanora-down": "quote-module-scss-module__1InMkG__fill-step-cyanora-down",
  "fill-step-future-fuscia": "quote-module-scss-module__1InMkG__fill-step-future-fuscia",
  "fill-step-future-fuscia-down": "quote-module-scss-module__1InMkG__fill-step-future-fuscia-down",
  "fill-step-linear-gradient-cyanora-to-future-fuscia": "quote-module-scss-module__1InMkG__fill-step-linear-gradient-cyanora-to-future-fuscia",
  "fill-step-midnight": "quote-module-scss-module__1InMkG__fill-step-midnight",
  "fill-step-off-white": "quote-module-scss-module__1InMkG__fill-step-off-white",
  "fill-step-right-before-midnight": "quote-module-scss-module__1InMkG__fill-step-right-before-midnight",
  "fill-step-springtime": "quote-module-scss-module__1InMkG__fill-step-springtime",
  "fill-step-vertical-gradient-cyanora-to-future-fuscia": "quote-module-scss-module__1InMkG__fill-step-vertical-gradient-cyanora-to-future-fuscia",
  "fill-step-vertical-gradient-cyanora-to-violet": "quote-module-scss-module__1InMkG__fill-step-vertical-gradient-cyanora-to-violet",
  "fill-step-white": "quote-module-scss-module__1InMkG__fill-step-white",
  "icon": "quote-module-scss-module__1InMkG__icon",
  "left": "quote-module-scss-module__1InMkG__left",
  "quote": "quote-module-scss-module__1InMkG__quote",
  "right": "quote-module-scss-module__1InMkG__right",
  "step-angry": "quote-module-scss-module__1InMkG__step-angry",
  "step-before-midnight": "quote-module-scss-module__1InMkG__step-before-midnight",
  "step-coal-mine-canary": "quote-module-scss-module__1InMkG__step-coal-mine-canary",
  "step-coal-mine-canary-down": "quote-module-scss-module__1InMkG__step-coal-mine-canary-down",
  "step-cold-steel": "quote-module-scss-module__1InMkG__step-cold-steel",
  "step-cyanora": "quote-module-scss-module__1InMkG__step-cyanora",
  "step-cyanora-down": "quote-module-scss-module__1InMkG__step-cyanora-down",
  "step-future-fuscia": "quote-module-scss-module__1InMkG__step-future-fuscia",
  "step-future-fuscia-down": "quote-module-scss-module__1InMkG__step-future-fuscia-down",
  "step-linear-gradient-cyanora-to-future-fuscia": "quote-module-scss-module__1InMkG__step-linear-gradient-cyanora-to-future-fuscia",
  "step-midnight": "quote-module-scss-module__1InMkG__step-midnight",
  "step-off-white": "quote-module-scss-module__1InMkG__step-off-white",
  "step-right-before-midnight": "quote-module-scss-module__1InMkG__step-right-before-midnight",
  "step-springtime": "quote-module-scss-module__1InMkG__step-springtime",
  "step-vertical-gradient-cyanora-to-future-fuscia": "quote-module-scss-module__1InMkG__step-vertical-gradient-cyanora-to-future-fuscia",
  "step-vertical-gradient-cyanora-to-violet": "quote-module-scss-module__1InMkG__step-vertical-gradient-cyanora-to-violet",
  "step-white": "quote-module-scss-module__1InMkG__step-white",
  "text": "quote-module-scss-module__1InMkG__text",
  "text-left": "quote-module-scss-module__1InMkG__text-left",
  "text-right": "quote-module-scss-module__1InMkG__text-right",
  "text-with-avatar": "quote-module-scss-module__1InMkG__text-with-avatar",
});
